var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogInBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3L2 4V5L3 6V19L5 21H19L21 19V6L22 5V4L21 3H3ZM19 6H5V19H19V6Z",
    fill: "#1E3966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 12.396L15.0046 12.404C15.0207 12.272 15.0369 12.136 15.0369 12C15.0369 11.864 15.0248 11.736 15.0086 11.604L15.0126 11.612L16 10.844L15.0167 9.156L13.8553 9.62L13.8594 9.624C13.649 9.464 13.4183 9.328 13.1674 9.224H13.1715L12.9853 8H11.0147L10.8366 9.228H10.8407C10.5898 9.332 10.3591 9.468 10.1487 9.628L10.1528 9.624L8.98735 9.156L8 10.844L8.98735 11.612L8.9914 11.604C8.97522 11.736 8.96308 11.864 8.96308 12C8.96308 12.136 8.97521 12.272 8.99545 12.404L8.9914 12.396L8.14163 13.056L8.00809 13.16L8.9914 14.84L10.1568 14.38L10.1487 14.364C10.3632 14.528 10.5938 14.664 10.8488 14.768H10.8366L11.0187 16H12.9813C12.9813 16 12.9934 15.928 13.0056 15.832L13.1593 14.772H13.1553C13.4062 14.668 13.6409 14.532 13.8553 14.368L13.8472 14.384L15.0126 14.844L15.996 13.164C15.996 13.164 15.9393 13.116 15.8624 13.06L15.0086 12.396V12.396ZM11.998 13.4C11.217 13.4 10.5817 12.772 10.5817 12C10.5817 11.228 11.217 10.6 11.998 10.6C12.779 10.6 13.4143 11.228 13.4143 12C13.4143 12.772 12.779 13.4 11.998 13.4Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogInBox);
export default __webpack_public_path__ + "static/media/cog-in-box.b391bf3c4cebae9b710191a8ce3c9f41.svg";
export { ForwardRef as ReactComponent };